var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mb-8"},[_vm._v(" Verbinde dich mit unserer API um neue Objekte und Zähler bzw. andere Geräte automatisch in unserem System anzulegen und lade deine Nutzer automatisiert ein. ")]),_c('client-secrets-list'),_c('div',{staticClass:"my-12"}),_c('api-documentation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }